import { render, staticRenderFns } from "./ShipperNew.vue?vue&type=template&id=7469311d&"
import script from "./ShipperNew.vue?vue&type=script&lang=js&"
export * from "./ShipperNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports